import React from "react"
import Stroke from "../../atoms/Stroke"
import Link from "next/link"
import CustomButton, { ButtonVariant } from "../../atoms/Button"
import classes from "./CustomListItem.module.css"
import classNames from "classnames"

export interface Classes {
  startIcon?: string
  content?: string
  endIcon?: string
}

interface Props {
  onClick?: () => void
  link?: string
  title?: React.ReactNode
  children?: React.ReactNode
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  separator?: boolean
  className?: string
  classes?: Classes
  style?: React.CSSProperties
}

const CustomListItem = ({
  onClick,
  link,
  title,
  children,
  startIcon,
  endIcon,
  separator,
  className,
  classes: userClasses,
  style,
}: Props) => {
  const Content = () => (
    <>
      {startIcon && (
        <div className={classNames(classes.startIcon, userClasses?.startIcon)}>
          {startIcon}
        </div>
      )}
      <div className={classNames("flex-1", userClasses?.content)} style={style}>
        {title && (
          <div
            style={{
              fontSize: "1.125rem",
            }}
          >
            {title}
          </div>
        )}
        {children}
      </div>
      <div className={classNames(classes.endIcon, userClasses?.endIcon)}>
        {endIcon}
      </div>
    </>
  )
  const Separator = () =>
    separator ? <Stroke color="disabled" className="my-1" /> : <></>

  const buttonProps = {
    variant: "text" as ButtonVariant,
    className,
    invariantCase: true,
    fullWidth: true,
    classes: {
      button: classes.button,
      inner: classes.buttonInner,
    },
  }

  if (onClick) {
    return (
      <div onClick={onClick}>
        <CustomButton {...buttonProps}>
          <Content />
        </CustomButton>
        <Separator />
      </div>
    )
  }

  if (link) {
    return (
      <Link href={link} passHref>
        <a>
          <CustomButton {...buttonProps}>
            <Content />
          </CustomButton>
          <Separator />
        </a>
      </Link>
    )
  }

  return (
    <div>
      <div className={className}>
        <Content />
      </div>
      <Separator />
    </div>
  )
}

export default CustomListItem
